import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import authService from '../services/authService';
import FormField from '../components/common/FormField';
import Alert from '../components/common/Alert';
import './ApplicantPages.css';

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const email = params.get('email') || '';
  const [values, setValues] = useState({ password: '', confirm: '' });
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (values.password.length < 8) return setError('Use at least 8 characters.');
    if (values.password !== values.confirm) return setError('The two passwords do not match.');
    setError('');
    setBusy(true);
    try {
      await authService.resetPassword({ token, email, password: values.password, password_confirmation: values.confirm });
      setDone(true);
    } catch (err) {
      const errors = err.response?.data?.errors;
      setError(errors ? Object.values(errors).flat().join(' ') : err.response?.data?.message || 'Your password could not be changed.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ap-center">
      <div className="ap-card ap-card--narrow">
        <h1 className="ap-brand"><Link to="/">TenantVerify SA</Link></h1>
        {!token || !email ? (
          <>
            <Alert type="error" message="This link is incomplete. Please use the link in your email, or ask for a new one." />
            <Link to="/forgot-password" className="ap-button ap-button--ghost">Ask for a new link</Link>
          </>
        ) : done ? (
          <>
            <h2>Password changed</h2>
            <p>You have been signed out everywhere else. You can log in with your new password now.</p>
            <Link to="/login" className="btn-primary ap-button">Log in</Link>
          </>
        ) : (
          <>
            <h2>Choose a new password</h2>
            <form onSubmit={submit} noValidate>
              {error && <Alert type="error" message={error} />}
              <FormField label="New password" name="password" type="password" value={values.password} onChange={(e) => setValues({ ...values, password: e.target.value })} required autoComplete="new-password" />
              <FormField label="Confirm new password" name="confirm" type="password" value={values.confirm} onChange={(e) => setValues({ ...values, confirm: e.target.value })} required autoComplete="new-password" />
              <button type="submit" className="btn-primary ap-button" disabled={busy}>{busy ? 'Saving...' : 'Change password'}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
